<template>
    <div>
        <div class="mb-4">
            <div
                v-for="(item, index) of content.newsbreaker"
                :key="index"
                class="form-group col-12 row mb-4"
            >
                <div class="col-11">
                    <div class="col-12 mb-2">
                        <label :for="`text_${index}`">
                            Text
                        </label>
                        <input
                            :id="`text_${index}`"
                            v-model="item.text"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    v.newsbreaker.$each[index].text.$error
                            }"
                            dir="auto"
                        />
                    </div>

                    <div class="col-12">
                        <label :for="`link_${index}`">
                            Link
                        </label>
                        <input
                            :id="`link_${index}`"
                            v-model="item.link"
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    v.newsbreaker.$each[index].link.$error
                            }"
                            dir="auto"
                        />
                    </div>
                </div>

                <div
                    v-if="content.newsbreaker.length > 1"
                    class="col-1 p-0 align-items-center justify-content-center"
                    style="display: flex"
                >
                    <button class="action-button" @click="removeLine(index)">
                        <i class="far fa-trash-alt" />
                    </button>
                </div>
            </div>

            <button
                class="btn btn-success waves-effect waves-light ml-4 mt-4"
                type="button"
                @click="addLine"
            >
                <i class="fas fa-plus-circle" /> Add Item
            </button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: false,
            default: () => ({})
        },
        v: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            content: {
                newsbreaker: []
            }
        };
    },

    watch: {
        content() {
            this.$emit('input', this.content);
        }
    },

    mounted() {
        this.content = { ...this.content, ...this.value };

        if (!this.content.newsbreaker.length) {
            this.addLine();
        }
    },

    methods: {
        addLine() {
            this.content.newsbreaker.push({
                text: '',
                link: ''
            });
        },

        removeLine(index) {
            this.content.newsbreaker.splice(index, 1);
        }
    }
};
</script>
